/**
 * Trending links progressively enhance to fill the TCS search field.
 * Native form submission now handles Enter and View all (R-013), including
 * the section-rendered type=product field. No competing location assignment.
 */
document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const link = target?.closest('.tcs-predictive__trending-link');

  if (!(link instanceof HTMLAnchorElement)) return;

  const term = link.dataset.searchTerm?.trim();
  if (!term) return;

  // Only take over when we can actually reach the field. If the panel's shape
  // changes upstream, the link stays a link and still works.
  const input = link
    .closest('predictive-search-component')
    ?.querySelector('input[ref="searchInput"]');
  if (!(input instanceof HTMLInputElement)) return;

  event.preventDefault();

  input.value = term;
  input.focus();
  input.dispatchEvent(
    new InputEvent('input', { bubbles: true, inputType: 'insertText', data: term }),
  );
});

// R-051 search focus return: start
// Return focus to the header search button when the search dialog closes.
// Horizon's dialog closes with the native dialog.close(), which hands focus back
// to whatever was focused when showModal() ran. Safari/WebKit does not focus a
// <button> on a click or tap, so after a pointer open nothing was focused and
// focus fell to <body> on Escape, the close button or an outside click
// (tasks/bugs/2026-10-06-search-escape-focus-return.md). Keyboard opens and
// Chromium were already right. This only acts when focus is on <body> or still
// inside the closed dialog, so a native return to another element (for example
// a link that kept focus through the open) is left alone.
// If the clicked button is hidden by then (the breakpoint changed while the
// dialog was open, and Horizon shows a different header button per breakpoint),
// focus goes to the first visible header search button instead; a hidden
// element is never focused. An opener remembered from a click that did not open
// the dialog is not cleared until the next close. That is harmless: it is only
// used when focus would otherwise be lost, and then it (or the visible fallback)
// is the right target. assets/dialog.js stays vendored and unchanged.
(() => {
  const OPENER = 'search-button button';

  /** @type {HTMLElement | null} */
  let opener = null;

  /** @param {Element | null} el */
  const isShown = (el) =>
    el instanceof HTMLElement &&
    el.isConnected &&
    el.getClientRects().length > 0 &&
    (typeof el.checkVisibility !== 'function' || el.checkVisibility({ visibilityProperty: true }));

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest(OPENER);
      if (button instanceof HTMLElement) opener = button;
    },
    true,
  );

  // `close` does not bubble; a capturing listener on document still sees it.
  document.addEventListener(
    'close',
    (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.closest('#search-modal')) return;

      const remembered = opener;
      opener = null;
      if (!remembered) return;

      // When `close` fires, a browser that had nothing to return to may still
      // report the hidden input (or the dialog) as active until its focus
      // fix-up moves it to <body>. Both count as lost.
      const active = document.activeElement;
      if (active && active !== document.body && !dialog.contains(active)) return;

      const target = isShown(remembered)
        ? remembered
        : [...document.querySelectorAll(OPENER)].find(isShown);
      if (target instanceof HTMLElement) target.focus({ preventScroll: true });
    },
    true,
  );
})();
// R-051 search focus return: end
